import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-doc-archive',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule
  ],
  templateUrl: './doc-archive.component.html',
  styleUrl: './doc-archive.component.scss'
})
export class DocArchiveComponent {

}
